/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBag: {
  name: 'bag';
  data: string;
} = {
  name: 'bag',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.17 6a3.001 3.001 0 0 1 5.659 0H9.17ZM8.001 8H6.795L4.257 19h15.486L17.204 8H8.001ZM16.9 6a5.002 5.002 0 0 0-9.8 0h-.305a2 2 0 0 0-1.949 1.55l-2.538 11A2 2 0 0 0 4.257 21h15.486a2 2 0 0 0 1.948-2.45l-2.538-11A2 2 0 0 0 17.204 6H16.9Z" fill="currentColor"/></svg>`,
};
